export const COMPANY_SNOWFLAKE = 'Snowflake';
export const COMPANY_PRICE_CHART = 'Price Chart';
export const COMPANY_NEWS = 'News';
export const COMPANY_INTRINSIC_VALUE_CALC = 'Intrinsic Value Calculation';
export const COMPANY_PE = 'Price based on Earnings (PE)';
export const COMPANY_PEG = 'Price Based on Expected Growth (PEG)';
export const COMPANY_PB = 'Price Based on Value of Assets (PB)';
export const COMPANY_EARNINGS_GROWTH_ESTIMATES =
  'Earnings and Revenue Growth Estimates';
export const COMPANY_EPS_ESTIMATES = 'Earnings per Share Growth Estimates';
export const COMPANY_FINANCIAL_POSITION_ANALYSIS = 'Financial Position';
export const COMPANY_DEBT_TO_EQUITY_HISTORY = 'Debt to Equity History';
export const COMPANY_DIVIDEND_YIELD_AND_PAYMENT = 'Dividend Yield and Payments';
export const COMPANY_CURRENT_PAYOUT = 'Current Payout to Shareholders';
export const COMPANY_FUTURE_PAYOUT = 'Future Payout to Shareholders';
export const COMPANY_CEO_COMPENSATION = 'CEO Compensation';
export const COMPANY_INSIDER_TRADING = 'Insider Trading';
export const COMPANY_OWNERSHIP_BREAKDOWN = 'Ownership Breakdown';
export const COMPANY_RETURNS = 'Returns';
export const COMPANY_INCOME_STATEMENT = 'Earnings and Revenue to Market Cap';
export const COMPANY_VALUATION_MULTIPLE_VS_PEERS =
  'Valuation Multiple Vs Peers';
export const COMPANY_KEY_VALUATION_METRICS = 'Key Valuation Metrics';
export const COMPANY_VALUATION_ANALYST_PRICE_TARGET = 'Analyst Price Targets';
export const PORTFOLIO_STATIC_COMPANY = 'Portfolio';
export const PORTFOLIO_SUMMARY = 'Summary';
export const PORTFOLIO_NEWS = 'News';
export const PORTFOLIO_VOL_vs_MARKET = 'Volatility vs Market';
export const PORTFOLIO_HISTORICAL_VALUE = 'Historical Value';
export const PORTFOLIO_CONTRIBUTORS_TO_RETURNS = 'Contributors to Returns';
export const PORTFOLIO_DIVERSIFICATION_BY_COMPANY =
  'Diversification By Company';
export const PORTFOLIO_DIVERSIFICATION_BY_INDUSTRY =
  'Diversification Across Industries';
export const PORTFOLIO_INTRINSIC_VALUE = 'Intrinsic Value';
export const PORTFOLIO_PE = 'Price based on Earnings (PE)';
export const PORTFOLIO_PEG = 'Price Based on Expected Growth (PEG)';
export const PORTFOLIO_PB = 'Price Based on Value of Assets (PB)';
export const PORTFOLIO_FUTURE_GROWTH_ANALYSIS = 'Future Annual Growth Analysis';
export const PORTFOLIO_PAST_ROE = 'Return on Equity (ROE)';
export const PORTFOLIO_PAST_ROA = 'Return on Assets (ROA)';
export const PORTFOLIO_PAST_ROCE = 'Return on Capital Employed (ROCE)';
export const PORTFOLIO_DEBT_LEVEL = 'Debt Level';
export const PORTFOLIO_DIVIDEND_PAYERS = 'Dividend Payers';
